import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class PackUpsellBanner extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by updating the banner.
   * @param {import('@shopify/events').ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html } = detail;
        const newBanner = html.querySelector('pack-upsell-banner');
        if (!newBanner) return;

        morph(this, newBanner, { childrenOnly: true });
        this.className = newBanner.className;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[pack-upsell-banner] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('pack-upsell-banner')) {
  customElements.define('pack-upsell-banner', PackUpsellBanner);
}
